import axios from 'axios';

import { CLOUD_FUNCTION_URL, GCP_FILE_UPLOAD_BUCKET } from '../../env';
import { getAuthHeaderForUser, handleAuthError } from '../auth/auth.util';
import type { ReportId } from './chat-client';

export type { ReportId };

const REPORT_PATHS: Record<ReportId, { path: string }> = {
  forecasting: { path: 'reports/syntiro_v2_5.html' },
  quantified_risk: { path: 'reports/syntiro-report-template.html' }
};

export async function fetchReportBlobUrl(reportId: ReportId): Promise<string> {
  const bucket = atob(GCP_FILE_UPLOAD_BUCKET);
  const { path } = REPORT_PATHS[reportId];

  const authHeader = await getAuthHeaderForUser();

  const response = await axios.post(
    `${CLOUD_FUNCTION_URL}/getSignedFileUrls`,
    { action: 'read', bucket, path },
    { headers: { ...authHeader } }
  );

  const signedUrl: string = response.data.data.urls[0].url;

  const fetchResponse = await fetch(signedUrl);

  if (!fetchResponse.ok) {
    if (fetchResponse.status === 401) {
      handleAuthError(fetchResponse);
      throw new Error('Unauthorized: session expired.');
    }
    throw new Error(`Report fetch failed with status ${fetchResponse.status}`);
  }

  const blob = await fetchResponse.blob();
  return URL.createObjectURL(blob);
}
